export default __webpack_public_path__ + "static/media/0032.d2a4920b.png";